
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { isNullish } from '@commonHelpers/math-utils';
import { LogoDto, LogoService } from '@commonServices/logo.service';

@Component({
    selector: 'lib-catalog-logo-img',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './catalog-logo-img.component.html',
    styleUrls: ['./catalog-logo-img.component.scss']
})
export class CatalogLogoImgComponent implements OnInit, OnChanges {

	public logo?: LogoDto;
	@Input({ required: true }) catalogKey?: string;
	@Input({ required: true }) alt?: string;
	@Input() isSmall = false;
	@Input() loading: 'lazy' | 'eager' = 'lazy'
	@Input() height?: string;
	@Input() width?: string;
	constructor(private logoService: LogoService,) {

	}

	ngOnInit(): void {

	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!isNullish(this.catalogKey)) {
			this.logo =
				this.isSmall ? this.logoService.getSmallLogosByKey(this.catalogKey) :
					this.logoService.getLargeLogosByKey(this.catalogKey);
		}

	}

}
